export default function StreamNotice() {
  return (
    <div className="space-y-2 mb-4">

      {/* Promotion Banner */}
      {/* <div className="rounded-lg overflow-hidden bg-[#1A1A2E] border border-white/10 shadow-sm">
        <div className="px-4 py-2 text-center text-white">
          <h4 className="text-sm sm:text-base font-medium leading-relaxed">
            ১ হাজার ফেসবুক ফলোয়ার মাত্র ৩ টাকা। নিতে ভিজিট করুনঃ{" "}
            <a
              href="https://smmten.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-400 hover:text-orange-300 font-semibold underline transition-colors"
            >
              smmten.com
            </a>{" "}
            এ
          </h4>
        </div>
      </div> */}

      {/* Loading Notice */}
      <div className="rounded-lg overflow-hidden bg-[#1A1A2E] border border-white/10 shadow-sm">
        <div className="px-4 py-2 text-center text-orange-400 text-sm sm:text-base font-medium">
          Please wait at least 1–2 minutes for the stream to load.
        </div>
      </div>

    </div>
  );
}